import { render } from "./wind-matrix.vue?vue&type=template&id=7c4b8b06&scoped=true"
import script from "./wind-matrix.vue?vue&type=script&lang=js"
export * from "./wind-matrix.vue?vue&type=script&lang=js"

import "./wind-matrix.vue?vue&type=style&index=0&id=7c4b8b06&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c4b8b06"]])

export default __exports__